<template>
  <div>
    <b-card class="bg-light-gray border-0 mt-2">
      <em class="fa fa-file-signature text-green pr-1 mr-2" />
      <b class="color">Información de rechazo</b>
      <ValidationObserver ref="observer">
        <div class="row ml-3 mt-4">
          <div class="col-md-4">
            <label class="data-title mb-1">Tipo de Archivo:</label>
            <p>Minuta de Rechazo de Servicios Compensatorios</p>
          </div>
          <div class="col-md-4">
            <label class="data-title mb-1">Nombre de Archivo:</label>
            <ValidationProvider
              v-slot="{ errors }"
              class="w-100"
              name="Documento"
              rules="required"
            >
              <CustomFileInput
                ref="fileUpload"
                v-model="documentFile"
                :disabled="isReadOnly"
                :attachment-id="documentAttachmentId"
                :name="documentFileName"
                display-style="normal"
                :on-download="downloadFile"
                :accept="'.pdf'"
                :error="errors[0]"
                custom-error-msg="Documento es requerido."
                label-position="left"
                @input="onFileChange"
              />
            </ValidationProvider>
          </div>
          <div v-if="!isReadOnly" class="col-md-4">
            <div class="text-right mt-2">
              <br />
              <ActionButton
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger ml-2"
                type="button"
                @click="cancel()"
              >
                Cancelar
              </ActionButton>
              <ActionButton
                v-if="hasFileChange"
                variant="success ml-2 m-0  px-4"
                type="button"
                @click="saveDocument()"
              >
                Guardar
              </ActionButton>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </b-card>
  </div>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import _generalService from '@/services/pei/general';
export default {
  name: 'RejectCompensatoryService',
  mixins: [alert],
  components: {
    CustomFileInput,
    ActionButton,
  },
  props: {
    documentAttachmentId: {
      default: null,
    },
    fileName: {
      default: null,
    },
    isReadOnly: {
      default: false,
    },
    compensatoryRequestNumber: {
      default: null,
    },
  },
  data() {
    return {
      documentFile: null,
      documentFileName: this.fileName,
    };
  },
  computed: {
    hasFileChange() {
      return this.documentFile != null;
    },
  },
  methods: {
    downloadFile(uid) {
      if (!uid) return;
      _generalService.downloadDocumentByAttachmentId(uid);
      this.$emit('download-file', uid);
    },
    onFileChange(newFile) {
      if (newFile) this.documentFileName = newFile.name;
    },
    async saveDocument() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      this.$emit('save-doc');
    },
    cancel() {
      this.$emit('cancel-section');
    },
  },
  watch: {
    documentFile(newValue, oldValue) {
      let dataTosend = {
        file: newValue,
        compensatoryRequestNumber: this.compensatoryRequestNumber,
      };
      this.$emit('document', dataTosend);
    },
  },
};
</script>
<style lang="scss" scoped>
.color-dark-gray {
  color: #3c5044;
}
</style>
